// A marmot, modelled facing +X: a plump upright body, small rounded ears and a
// short tail. Ported 1:1 from age-of-mcp's classic marmot.ts.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  return [
    { geometry: new THREE.IcosahedronGeometry(0.034, 0), color: "#8a6e44",
      position: [0, 0.04, 0], scale: [1, 1.3, 0.95] },               // plump body
    { geometry: new THREE.IcosahedronGeometry(0.022, 0), color: "#9a7c4e",
      position: [0.012, 0.085, 0] },                                 // head
    { geometry: new THREE.IcosahedronGeometry(0.007, 0), color: "#7a6038",
      position: [0.0, 0.105, 0.016] },                              // ear
    { geometry: new THREE.IcosahedronGeometry(0.007, 0), color: "#7a6038",
      position: [0.0, 0.105, -0.016] },
    { geometry: new THREE.ConeGeometry(0.008, 0.024, 4), color: "#7a6038",
      position: [0.03, 0.085, 0], rotation: [0, 0, -Math.PI / 2] },    // snout
    { geometry: new THREE.IcosahedronGeometry(0.02, 0), color: "#caa878",
      position: [0.018, 0.04, 0], scale: [0.8, 1.1, 1] },            // pale belly
    { geometry: new THREE.CylinderGeometry(0.006, 0.004, 0.03, 4), color: "#6e5630",
      position: [-0.03, 0.03, 0], rotation: [0, 0, 1.0] },           // short tail
  ];
}

export const marmot = defineModel({
  id: "marmot",
  batchId: "standard",
  name: "Marmot",
  tags: ["creature","marmot","low-poly","age-of-mcp","classic"],
  summary: "Low-poly marmot.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.07,
  parts: () => partsFor(),
  animations: [],
});
